var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangle158(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V23C28 25.2091 26.2091 27 24 27H4C1.79086 27 0 25.2091 0 23V4Z",
    fill: "#FFF9D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28H0ZM29 23C29 25.7614 26.7614 28 24 28H5C2.23858 28 0 25.7614 0 23C0 24.6569 1.79086 26 4 26H24C25.6569 26 27 24.6569 27 23H29ZM0 27V0V27ZM24 0C26.7614 0 29 2.23858 29 5V23C29 25.7614 26.7614 28 24 28V26C25.6569 26 27 24.6569 27 23V4C27 1.79086 25.6569 0 24 0Z",
    fill: "#EFCB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle158);
export default __webpack_public_path__ + "static/media/Rectangle 158.1b1b5116ab17c9e844bd0f4cafd735b9.svg";
export { ForwardRef as ReactComponent };